import PersonalInsurance from './views/personalInsurance.c';
export default PersonalInsurance;
